import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
render(<App data-id="element-226" />, document.getElementById('root'));
// Load Google Fonts asynchronously — non-render-blocking
if (typeof window !== 'undefined') {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700;800;900&display=swap';
  link.media = 'print';
  link.onload = function () {
    link.media = 'all';
  };
  document.head.appendChild(link);
  // Preconnect hints for faster font loading
  const preconnect1 = document.createElement('link');
  preconnect1.rel = 'preconnect';
  preconnect1.href = 'https://fonts.googleapis.com';
  document.head.appendChild(preconnect1);
  const preconnect2 = document.createElement('link');
  preconnect2.rel = 'preconnect';
  preconnect2.href = 'https://fonts.gstatic.com';
  preconnect2.crossOrigin = 'anonymous';
  document.head.appendChild(preconnect2);
}
// Defer Meta Pixel — load after page is interactive
if (typeof window !== 'undefined') {
  const loadPixel = () => {
    ;
    (function (f: any, b: any, e: any, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      b.head.appendChild(t);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    (window as any).fbq('init', '1688179945683486');
    (window as any).fbq('track', 'PageView');
  };
  if ('requestIdleCallback' in window) {
    ;
    (window as any).requestIdleCallback(loadPixel);
  } else {
    setTimeout(loadPixel, 2000);
  }
}